import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';

import SingleSelect from '../../../common/components/SingleSelect/SingleSelect';
import {
  OptionBlock,
  Subtitle,
  Title,
} from '../../../common/styled-components';
import { useFunnelStorage } from '../../storage/Storage';
import { StepWrapper } from '../../styled-components';
import { generateStepAnalytics, isUsUser, STEP_KEY } from '../../utils';

import { hasInsuranceOptions, SUBSTEPS } from './constants';

const analytics = new Analytics();

const Parent = ({ position, setSubStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const savedInsurance = storage.get(STEP_KEY.INSURANCE);

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_insurance',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const handleClick = (option, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_insurance',
      name: 'wizard',
      section: 'insurance',
      position: [index + 1],
      ...generateStepAnalytics(position, storage, {
        response: option.id,
      }),
      content: {
        reco_has_insurance: option.id,
      },
    });

    storage.save(STEP_KEY.INSURANCE, { hasInsurance: option.id }, false);
    decideWhichSubStep(option.data);
  };

  const decideWhichSubStep = (hasInsurance) => {
    if (!hasInsurance) {
      // if US user, go to alt payment options
      if (isUsUser(storage)) {
        setSubStep(SUBSTEPS.ALT_PAYMENT_PLANS);
      } else {
        setSubStep(SUBSTEPS.HAS_SOCIAL_ASSISTANCE);
      }
    } else {
      setSubStep(SUBSTEPS.DETAILS);
    }
  };

  return (
    <div data-testid="main-insurance">
      <Title id="title">Do you have dental insurance?</Title>
      <Subtitle>
        Why do we ask? We want to connect you with a dentist who accepts your
        plan!
      </Subtitle>
      <StepWrapper>
        <form>
          <OptionBlock row={2}>
            {hasInsuranceOptions.map((option, i) => (
              <SingleSelect
                key={option.id}
                id={option.id}
                title={option.title}
                description={option.description}
                describedBy="title"
                Icon={option.icon}
                onChange={() => handleClick(option, i)}
                selected={get(savedInsurance, 'hasInsurance') === option.id}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

Parent.defaultProps = {
  position: '',
};

Parent.propTypes = {
  position: PropTypes.string,
  setSubStep: PropTypes.func.isRequired,
};

export default Parent;
